import { render, staticRenderFns } from "./BaseRegister.vue?vue&type=template&id=26370e1d&scoped=true"
import script from "./BaseRegister.vue?vue&type=script&lang=js"
export * from "./BaseRegister.vue?vue&type=script&lang=js"
import style0 from "./BaseRegister.vue?vue&type=style&index=0&id=26370e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26370e1d",
  null
  
)

export default component.exports